// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Frg8","icon":"styles_icon__2aiCc"};